import { z } from 'zod';

const PathsSchema = z.object({
  auth: z.object({
    signIn: z.string().min(1),
    signUp: z.string().min(1),
    verifyMfa: z.string().min(1),
    callback: z.string().min(1),
    passwordReset: z.string().min(1),
    passwordUpdate: z.string().min(1),
  }),
  app: z.object({
    home: z.string().min(1),
    personalAccountSettings: z.string().min(1),
    personalAccountBilling: z.string().min(1),
    personalAccountBillingReturn: z.string().min(1),
    accountHome: z.string().min(1),
    accountProducts: z.string().min(1),
    accountProductCreator: z.string().min(1),
    accountProductEditor: z.string().min(1),
    accountLinks: z.string().min(1),
    accountLinkCreator: z.string().min(1),
    accountLinkEditor: z.string().min(1),
    accountSettings: z.string().min(1),
    accountBilling: z.string().min(1),
    accountMembers: z.string().min(1),
    accountClients: z.string().min(1),
    accountBillingReturn: z.string().min(1),
    accountComputingPowers: z.string().min(1),
    accountPaymentTx: z.string().min(1),
    accountSubscriptionTx: z.string().min(1),
    accountOnboarding: z.string().min(1),
    accountMessages: z.string().min(1),
    accountWhatsapp: z.string().min(1),
    joinTeam: z.string().min(1),
    affiliate: z.string().min(1),
  }),
  admin: z.object({
    computingActions: z.string().min(1),
    computingActionsEditor: z.string().min(1),
    computingPowerTx: z.string().min(1)
  })
});

const pathsConfig = PathsSchema.parse({
  auth: {
    signIn: '/auth/sign-in',
    signUp: '/auth/sign-up',
    verifyMfa: '/auth/verify',
    callback: '/auth/callback',
    passwordReset: '/auth/password-reset',
    passwordUpdate: '/update-password',
  },
  app: {
    home: '/home',
    personalAccountSettings: '/home/settings',
    personalAccountBilling: '/home/billing',
    personalAccountBillingReturn: '/home/billing/return',
    accountHome: '/home/[account]',
    accountProducts: `/home/[account]/products`,
    accountProductEditor: `/home/[account]/products/editor/[content_id]`,
    accountProductCreator: `/home/[account]/products/editor`,
    accountLinks: `/home/[account]/links`,
    accountLinkEditor: `/home/[account]/links/editor/[content_id]`,
    accountLinkCreator: `/home/[account]/links/editor`,
    accountSettings: `/home/[account]/settings`,
    accountBilling: `/home/[account]/billing`,
    accountMembers: `/home/[account]/members`,
    accountClients: `/home/[account]/clients`,
    accountBillingReturn: `/home/[account]/billing/return`,
    accountComputingPowers: `/home/[account]/computing-powers`,
    accountPaymentTx: `/home/[account]/payment-tx`,
    accountSubscriptionTx: `/home/[account]/subscription-tx`,
    accountOnboarding: `/home/[account]/onboarding`,
    accountMessages: `/home/[account]/messages`,
    accountWhatsapp: `/home/[account]/whatsapp`,
    joinTeam: '/join',
    affiliate: '/home/affiliate',
  },
  admin: {
    computingActions: '/admin/computing-actions',
    computingActionsEditor: '/admin/computing-actions/editor',
    computingPowerTx: '/admin/computing-power-tx',
  }
} satisfies z.infer<typeof PathsSchema>);

export default pathsConfig;
